module.exports = __webpack_public_path__ + "bg912-orange-2f2e119c051431326dcbad7e9b28cc11.png";